<template>
  <div class="container" id="profile_section">
    <div>
      <div class="page-header gold mt-4 mb-2">
        <back-btn to="/dashboard"></back-btn>

        <h2 class="mb-0">
          <span> Support</span>
        </h2>
      </div>

      <!-- dashboard modal
		<b-modal id="modal-dashboard" :title="modal_dashboard.title" ref="modal-dashboard" size="xl" hide-footer>
				
		</b-modal>
		-->

      <!-- edit user profile modal-->

      <div class="row" id="members_wrap">
        <template v-if="members && members.length > 2">
        <div class="col-md-6 my-1">
          <b-form-group class="mb-0">
            <b-input-group size="sm">
              <b-form-input
                id="filter-input"
                v-model="filter"
                type="search"
                placeholder="Search Coaches"
              ></b-form-input>

              <b-input-group-append>
                <b-button :disabled="!filter" @click="filter = ''"
                >Clear</b-button
                >
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </div>

        <div class="col-md-3 col-5 my-1">
          <b-form-group class="mb-0">
            <b-form-select
              id="per-page-select"
              v-model="perPage"
              :options="pageOptions"
              size="sm"
            ></b-form-select>
          </b-form-group>
        </div>

        <div class="col-md-3 col-7 my-1">
          <b-pagination
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            align="right"
            size="sm"
            class="my-0"
          ></b-pagination>
        </div>
        </template>

        <div class="col-12">
          <b-list-group
            v-for="item in members"
            :key="item.id"
            id="members_sharing"
            class="text-left mb-2"
          >
            <b-list-group-item style="border:0;">
              <div class="coach-container">
                <div class="row" style="gap: 20px">
                  <div class="col-sm-auto image-container d-flex flex-column align-items-center p-0">
                    <img
                      v-if="!item.profile_image"
                      class="image"
                      src="/profile_images/default.png"
                      alt="Coach Default Picture"
                    />
                    <img
                      v-else-if="item.profile_image"
                      class="image"
                      :src="item.profile_image"
                      alt="Coach Personal Picture"
                      height="185"
                    />

                    <div class="d-flex align-items-baseline" style="gap: 4px">

                      <b-form-rating
                        v-model="item.rating"
                        class="mb-2"
                        style="color: rgb(214, 182, 116)"
                        color="primary"
                        inline
                        no-border
                        size="sm"
                        readonly
                      ></b-form-rating>

                      <button class="border-0 bg-white" @click="showRatingModal(item)">
                        <i style="color: rgb(214, 182, 116)" class="fas fa-plus-circle" title="Add your rating"></i>
                      </button>

                    </div>

                    <router-link :to="`/chatbox/${item.id}`">
                      <b-button style="line-height: 1">Chat now</b-button>
                    </router-link>

                  </div>
                  <div class="col info-container p-0">

                    <h2 class="name">
                      {{ item.first_name }} {{ item.last_name }}
                    </h2>

                    <div v-if="item.summary !== 'null' && item.summary">
                      <h3 class="heading">Summary</h3>
                      <p>{{ item.summary }}</p>
                    </div>

                    <div v-if="item.expertise !== 'null' && item.expertise">
                      <h3 class="heading">Expertise</h3>
                      <p>{{ item.expertise }}</p>
                    </div>

                    <div class="d-flex" style="gap: 2px">
                      <a :href="item.linkedin | link" target="_blank" v-if="item.linkedin && item.linkedin !== 'null'">
                        <img src="/icons/linkedin.png" class="social-icon" />
                      </a>
                      <a :href="item.facebook | link" target="_blank" v-if="item.facebook && item.facebook !== 'null'">
                        <img src="/icons/facebook.png" class="social-icon" />
                      </a>
                      <a :href="item.instagram | link" target="_blank" v-if="item.instagram && item.instagram !== 'null'">
                        <img src="/icons/instagram.png" class="social-icon" />
                      </a>
                      <a :href="item.twitter | link" target="_blank" v-if="item.twitter && item.twitter !== 'null'">
                        <img src="/icons/twitter.png" class="social-icon" />
                      </a>
                      <a :href="item.tiktok | link" target="_blank" v-if="item.tiktok && item.tiktok !== 'null'">
                        <img src="/icons/tiktok.png" class="social-icon" />
                      </a>
                    </div>

                  </div>
                </div>
              </div>
            </b-list-group-item>
            <br />
          </b-list-group>
        </div>

        <div v-if="members && members.length > 2" class="col-12 my-1">
          <b-pagination
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            align="right"
            size="sm"
            class="my-0"
          ></b-pagination>
        </div>

        <div class="row small"></div>
      </div>
    </div>

    <b-modal
      ref="modalCoachRatingRef"
      :title="`Add your rating for ${coachToRate?.first_name} ${coachToRate?.last_name}`"
      ok-title="Submit"
      hide-footer
    >

      <div class="d-flex flex-column align-items-center">

        <b-form-rating
          v-model="coachRating"
          variant="warning"
          class="mb-2 w-100"
          no-border
          inline
          size="md"
        ></b-form-rating>

        <b-button class="text-decoration-none" @click="saveRating" :disabled="loading.saveRating">
          Submit <b-spinner small v-if="loading.saveRating"></b-spinner>
        </b-button>
      </div>

    </b-modal>


  </div>
</template>

<script>
import axios from "@/axios";
import BackBtn from "@/components/BackBtn.vue";

export default {
  components: {BackBtn},
  data() {
    return {
      modal: {
        title: "",
        submitDisabled: true,
        member: {},
        errors: {
          process: "",
        },
      },
      modal_dashboard: {
        title: "",
        member: {},
      },
      modal_member_default: {
        id: 0,
        first_name: "",
        last_name: "",
        user_name: "",
        email: "",
        phone: "",
        status: 1,
        level: 20,
      },
      options: {
        levels: [
          { value: 0, text: "Pending" },
          { value: 20, text: "Member" },
          { value: 30, text: "Team Coach" },
          { value: 50, text: "Editor" },
          { value: 90, text: "Admin" },
        ],
        statuses: [
          { value: 0, text: "Closed" },
          { value: 1, text: "Active" },
        ],
      },
      errors: {},
      members: null,
      fields: [
        { key: "first_name", sortable: true, label: "First Name", class: "" },
        { key: "last_name", sortable: true, label: "Last Name", class: "" },

        { key: "summary", sortable: true, label: "Summary", class: "" },
        { key: "expertise", sortable: true, label: "Expertise", class: "" },
      ],
      isBusy: true,
      sortBy: "timestamp",
      sortDirection: "desc",
      sortDesc: true,
      totalRows: 0,
      currentPage: 1,
      perPage: 50,
      pageOptions: [
        { value: 50, text: "Num to Show" },
        25,
        50,
        100,
        { value: 500, text: "All" },
      ],
      filter: null,
      filterOn: [],
      muse: {
        file: null,
        processing: 0,
        message: "",
      },
      coachToRate: null,
      coachRating: 0,
      loading: {

      }
    }
  },
  methods: {
    arrayElmGet(obj, value) {
      if (parseInt(value) === 99) {
        return "WebMaster";
      }
      const entries = Object.entries(obj);
      for (const v of entries) {
        if (parseInt(v[1].value) === parseInt(value)) {
          return v[1].text;
        }
      }
      return null;
    },

    displayOptionsSet() {
      this.$route.meta.title = "Coaches";
    },

    showRatingModal(coach) {
      this.coachToRate = coach
      this.$refs['modalCoachRatingRef'].show()

      axios(`getUserCoachRating?coachId=${coach.id}`)
        .then(({ data }) => {
          this.coachRating = data
        })
    },

    saveRating() {
      if (! this.coachRating) {
        return
      }

      const data = new URLSearchParams();
      data.append('coach_id', this.coachToRate.id);
      data.append('rating', this.coachRating);

      this.loading.saveRating = true

      axios({
        url: `addCoachRating`,
        method: 'post',
        data: {
          coach_id: this.coachToRate.id,
          rating: this.coachRating
        }
      })
        .then(({ data }) => {
          this.coachToRate.rating = data
          this.$refs['modalCoachRatingRef'].hide()
          this.loading.saveRating = false
        })
    },

    getMembers() {
      let _this = this;

      axios('coachesGet')
        .then(function(response) {
          _this.isBusy = false;
          if (response.data.status == 1) {
            _this.members = response.data.members;
          } else {
            _this.members = null;
          }
          _this.totalRows = _this.members.length;
        })
        .catch(function() {
          console.log("Error: boardDataGet.");
        });
    },
  },
  created() {},
  mounted() {
    this.displayOptionsSet();
    this.getMembers();
  },
  watch: {},
  filters: {
    link: function (link) {
      if (!link) return ''

      if (link.startsWith('http') || link.startsWith('/')) {
        return link
      }

      return `//${link}`
    }
  }
};
</script>

<style scoped>
th.score_width {
  min-width: 180px !important;
}
th.last_session {
  min-width: 160px !important;
}
.coach-container {
  margin-left: 50px;
  margin-right: 50px;
  padding: 10px;
}

.image {
  max-width: 185px;
  padding: 10px;
  padding-top: 5px;
  padding-right: 0px;
}

.heading {
  font-size: 115%;
}

.social-icon {
  height: 20px;
  width: 20px;
}

.coach-rating {
  border-radius: 24px;
  /*color: rgb(214, 182, 116);*/
  background-color: rgb(214, 182, 116);
  height: 24px;
  /*width: 80%;*/
}
.page-header {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 14px;
  position: relative;
}
</style>
